import React, { useState } from 'react';

import CustomDropdown from '@components/CustomDropdown';

import { useFetchCompositionListQuery } from '@features/material-requisition/api/materialRequisitionApi';

const Composition = ({ addCompositions, errors, materialIndex }) => {
	const { data: compositions } = useFetchCompositionListQuery();
	const [fields, setFields] = useState([{ id: 1, percentage: 0, composition: '' }]);

	const handlePercentageChange = (index, value) => {
		const updatedFields = [...fields];
		updatedFields[index].percentage = value;
		setFields(updatedFields);
		addCompositions(updatedFields);
	};

	const handleCompositionChange = (index, value) => {
		const updatedFields = [...fields];
		updatedFields[index].composition = value;
		setFields(updatedFields);
		addCompositions(updatedFields);
	};

	const handleBlur = (index) => {
		if (fields[index]?.percentage) {
			const totalPercentage = fields.reduce((sum, field) => sum + field.percentage, 0);
			if (totalPercentage < 100) {
				setFields([...fields, { id: fields.length + 1, percentage: 0, composition: '' }]);
			}
		}
	};

	return (
		<>
			{fields.map((field, index) => (
				<div className="col-md-6" key={field.id}>
					<div className="form-group composition-item mb-0">
						<label>{index === 0 ? 'Composition *' : <span className="invisible">.</span>}</label>
						<div className="d-flex">
							<input
								className="input-percentage pl-4"
								max={100}
								min="0.1"
								type="number"
								name="percentage"
								value={field.percentage || ''}
								onChange={(e) => handlePercentageChange(index, parseFloat(e.target.value))}
								onBlur={() => handleBlur(index)}
							/>
							<p className="percentage">%</p>
							<div className="select-component">
								<div className="form-group size36">
									<CustomDropdown
										type="addItem"
										isAddNew={false}
										onItemClick={(selected) => handleCompositionChange(index, selected)}
										items={compositions}
										selectedItem={field.composition.value}
										onBlur={() => handleBlur(index)}
									/>
								</div>
							</div>
						</div>
						{errors?.[`composition_percentage_${materialIndex}_${index}`] && (
							<p className="error d-block">
								{errors?.[`composition_percentage_${materialIndex}_${index}`]}
							</p>
						)}
						{errors?.[`composition_type_${materialIndex}_${index}`] && (
							<p className="error d-block">
								{errors?.[`composition_type_${materialIndex}_${index}`]}
							</p>
						)}
					</div>
				</div>
			))}
		</>
	);
};

export default Composition;
